import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Container, List, Icon } from '@pella/sash-framework';
import { getCookie, monetateDataLayer } from '../../utilities/functions';
import { useOktaAuth } from '../../../hooks/use-okta-auth';
import { isValidArray } from '../../utilities/validations';

import CTA from '../cta';
import BreadcrumbList from '../structured-data/breadcrumbs';

const Breadcrumbs = ({ data, currentUrl, className, ...other }) => {
	const { isLogged, profile } = useOktaAuth();
	const [isPro, setIsPro] = useState(false);

	useEffect(() => {
		if (isValidArray(data?.back_pages)) sendDataToMonetate(data);
	}, [data]);

	useEffect(() => {
		if (getCookie('CustomerType') === 'Professional' || (getCookie('CustomerType') == null && isLogged && profile?.isPro)) {
			setIsPro(true);
		} else {
			setIsPro(false);
		}
	}, [isLogged, profile?.isPro]);

	function sendDataToMonetate(data) {
		let bcArr = ['Home'];
		data.back_pages.forEach((item) => bcArr.push(item?.link?.title));
		monetateDataLayer('addBreadcrumbs', bcArr);
	}

	if (!data?.active_page || !currentUrl) return null;

	return (
		<>
			<div
				id='breadcrumbs'
				className={`breadcrumbs py-2 ${className || ''}`}
				data-testid='breadcrumbs'
				{...other}
			>
				<Container>
					<List
						layout='inline'
						bullets='none'
						className={`breadcrumbs-list !flex-nowrap items-center overflow-x-auto overflow-y-hidden text-black [&>li+li]:before:mx-[7px] [&>li+li]:before:content-['/']`}
					>
						<li className='breadcrumbs-listItem-home text-sm leading-3'>
							<Link
								to={isPro ? '/professionals/' : '/'}
								className='block no-underline'
							>
								<Icon
									name='other_houses'
									className='block'
									size={18}
								/>
								<span className='sr-only'>Home</span>
							</Link>
						</li>

						{isValidArray(data.back_pages) &&
							data.back_pages.map((link, index) => (
								<li
									className='breadcrumbs-listItem text-sm leading-3'
									key={index}
								>
									<CTA
										{...(data.$?.[`back_pages__${index}`] ?? {})}
										data={link}
										className='decoration-black decoration-auto'
									/>
								</li>
							))}

						{data.active_page && (
							<li
								{...(data.$?.active_page ?? {})}
								className='breadcrumbs-listItem-current text-sm leading-3'
							>
								{data.active_page}
							</li>
						)}
					</List>
				</Container>
			</div>

			{/* Structured Data - BreadcrumbList */}
			<BreadcrumbList
				links={data?.back_pages}
				activePage={data?.active_page}
				currentUrl={currentUrl}
			/>
		</>
	);
};

Breadcrumbs.propTypes = {
	data: PropTypes.object.isRequired,
	currentUrl: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export default Breadcrumbs;
